
function onmenu(type){ 
	if (type=='add') {
		$('.topnav').addClass('topnav-on');
		$('.topnav').after("<div class='topnav-bg' onclick=onmenu('remove')></div>");
	}
	if (type=='remove') {
		$('.topnav').removeClass('topnav-on');
		$(".topnav-bg").remove();
	}
}

function onrow(classname){
	$(classname).toggle();
}

//FAQ大类切换

function faqonqh(classname){
	$(classname).toggle();
}

//生成一个随机数字
function sj() {
    //x上限，y下限     
    var x = 9;
    var y = 1;
    var rand = parseInt(Math.random() * (x - y + 1) + y);
    $("#sjsz").html("").append(rand);
}


//产品页面生成一个随机订单数
function sjorders(code) {
    var now = new Date();
    var date = new Date();

	now.getYear(); //获取当前年份(2位)
	now.getFullYear(); //获取完整的年份(4位)
	now.getMonth(); //获取当前月份(0-11,0代表1月)
	now.getDate(); //获取当前日(1-31)

	var code_int = parseInt(code.substring(code.length-4)); //截取字符串后四位并转为数字类型


    sde = now.getFullYear() + now.getYear() + now.getMonth() + now.getDate() + code_int;
    $('.ordersl').html(sde +' orders');
}


//弹出优惠券提示框
/*function qjtcc() {

	var qjtcc_html  ='<div class="qj-tcc">'
     	qjtcc_html +='	<div class="yhj-kj">'
     	qjtcc_html +='		<h1>Congrats!!</h1>'
     	qjtcc_html +='		<p>A coupon code just for you</p>'
     	qjtcc_html +='		<div class="hy_k">LUV15<div class="jiandao"></div>'
     	qjtcc_html +='	</div>'
     	qjtcc_html +='	<span>Only <font color="#e71b32">2</font>/100 left available, apply it when you checkout</span>'
     	qjtcc_html +='	<i onclick="qjtcc_off()">&#xe727;</i>'
     	qjtcc_html +='	</div>'
     	qjtcc_html +='</div>'
	$("body").append(qjtcc_html);
  
	setTimeout(function(){
		$(".qj-tcc").css("opacity","1");
	},500);
}*/
//关闭弹出优惠券提示框
function qjtcc_off() {
	$(".qj-tcc").css("opacity","0");
	setTimeout(function(){
		$(".qj-tcc").remove();
	},500);

}
//打开尺寸说明
function seelg_on() {
	var qjtcc_html  ='<div class="qj-tcc">'
     	qjtcc_html +='	<div class="seelg-kj">'
     	qjtcc_html +='		<img src="https://cdn.shopify.com/s/files/1/0061/0746/3762/files/QDT.jpg?1286">'
     	qjtcc_html +='		<i onclick="qjtcc_off()">&#xe727;</i>'
     	qjtcc_html +='	</div>'
     	qjtcc_html +='</div>'
    $("body").append(qjtcc_html);
	setTimeout(function(){
		$(".qj-tcc").css("opacity","1");
	},100);
}



$(function() {
	//FAQ
	$(".faqs_content > ul > li > p").click(function(){
	  $(this).siblings('.zlm').toggle();
	});

	$(".faqs_content > ul > li > .zlm > p").click(function(){
	  $('.span').hide();
	  $(this).siblings('.span').toggle();
	});

	//导航栏
	$(".n_t").mouseover(function(){
	  $(this).find('ul').addClass('ul-hover');
	});

	//导航栏
	$(".n_t").mouseout(function(){
	  $(this).find('ul').removeClass('ul-hover');
	});

	//生成一个随机数字
	sj();
  
  

	//定时弹出优惠券提示框,时间是随机生成的数字
    var x = 10000;
    var y = 50000;
    var rand = parseInt(Math.random() * (x - y + 1) + y);  
	setTimeout(function(){
		qjtcc();
	},rand);

    
})

//头部文字滚动
var toptitle_aa = 0;
function toptitle_fade(){
	if(toptitle_aa%2){
	  $(".toptitle p").hide().text("Free Gift Pack(Value $20) For Every Order").fadeIn();
	}
	else{      
	  $(".toptitle p").hide().text("Free Shipping worldwide via Express").fadeIn();
	}
	toptitle_aa++;
}
window.setInterval("toptitle_fade();",4000); 



//获取的日期加一天 date参数是要进行加减的日期，days参数是要加减的天数
function gitdate_days(date,days){ 
	var d=new Date(date); //当前时间
	d.setDate(d.getDate()+days); 
	var m=d.getMonth()+1;
	//return d.getFullYear()+'-'+m+'-'+d.getDate();  
	return d.getDate() //输出当前日
} 

//打开品牌介绍
function open_brand_favorites_views(url) {
    jQuery(".brand-favorites-views").addClass("brand-favorites-views-display");

}
//关闭品牌介绍
function cancel_brand_favorites_views() {
    jQuery(".brand-favorites-views").removeClass("brand-favorites-views-display");
}
